import React from "react";
import { TooltipPlacement } from "antd/es/tooltip";
import TooltipWithInfoIcon from "../../ui-kit/ITooltip/TooltipWithInfoIcon";

export const withInfoTooltipHoc = <T extends Record<string, any>>(
  Component: React.ComponentType<T>,
) => {
  function WrappedComponent({
    children,
    title,
    placement,
    wrappedClassName,
    ...props
  }: {
    children?: React.ReactNode;
    title: React.ReactNode;
    placement: TooltipPlacement;
    wrappedClassName?: string;
  } & T) {
    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: "10px" }}
        className={wrappedClassName}
      >
        <Component {...props}>{children}</Component>

        <TooltipWithInfoIcon placement={placement} title={title} />
      </div>
    );
  }
  return WrappedComponent;
};
